// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.RoleTypeDropdown.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'share/components/controls/Izenda.DropDown';
import { get, filter, find, pick, map } from 'lodash/fp';
import connect from 'share/enhancers/Izenda.Connect';
import { ROLE_TYPES } from 'logic/data/Izenda.RoleSetupConstants';

/**
 * On change role type
 * @param {Object} changedValue
 */
function onChangeRoleType(changedValue: Object) {
  this.setRoleTemplate(changedValue.value);
}

function RoleTypeDropdown(props: Object) {
  const {
    store,
    store: { roleDetail },
    authorization,
    authorizationConstants: { PERMISSION_KEY: permissionKeys },
    readOnly
  } = props;

  const canGrantFullReportDashboardAccess = authorization.checkPrivileges([
    permissionKeys.RoleSetupGrantRoleWithFullReportAndDashboardAccessValue
  ]);

  const options = map(pick(['id', 'name']), store.roleTemplateList);

  if (!canGrantFullReportDashboardAccess) {
    const adminOption = find(roleTemplate => roleTemplate.id == ROLE_TYPES.Administrator, options);
    adminOption && (adminOption.hidden = true);
  }

  return (
    <Dropdown
      className='izenda-RoleInfo-type'
      value={get('roleType', roleDetail)}
      valueField='id'
      labelField='name'
      options={options}
      disabled={readOnly}
      onChange={onChangeRoleType.bind(store)}
    />
  );
}

RoleTypeDropdown.propTypes = {
  readOnly: PropTypes.bool,
  store: PropTypes.object.isRequired
};

export default connect()(RoleTypeDropdown);



// WEBPACK FOOTER //
// ./ui/modules/Settings/RoleSetup/RoleDetail/Izenda.RoleTypeDropdown.js